"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_acdc_1 = require("@seaweb/react-acdc");
var color_1 = require("@seaweb/coral/utils/color");
var useForkRef_1 = __importDefault(require("@seaweb/coral/hooks/useForkRef"));
var warnMissingIndex_1 = __importDefault(require("@seaweb/coral/utils/warnMissingIndex"));
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var Selected_1 = __importDefault(require("@seaweb/coral/components/icons/Selected"));
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var useEventValue_1 = __importDefault(require("@seaweb/coral/hooks/useEventValue"));
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var SelectContext_1 = require("./SelectContext");
var StyledSelectedIcon = styled_1.default(Selected_1.default).attrs({
    'data-coral-select-option-selected-icon': '',
    size: 16,
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n\n  ", "\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    right: ", "px;\n  "], ["\n    right: ", "px;\n  "])), 3 * theme.spacing.factor);
});
var Option = styled_1.default.li(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  max-width: 100%;\n  min-height: 36px;\n  line-height: 1.43;\n  border-radius: 2px;\n  box-sizing: border-box;\n  position: relative;\n  transition: all 0.1s ease;\n  cursor: pointer;\n\n  ", "\n\n  ", "\n"], ["\n  max-width: 100%;\n  min-height: 36px;\n  line-height: 1.43;\n  border-radius: 2px;\n  box-sizing: border-box;\n  position: relative;\n  transition: all 0.1s ease;\n  cursor: pointer;\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var isKeyboardHighlighted = _a.isKeyboardHighlighted, theme = _a.theme;
    return styled_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ",
        "\n  "])), isKeyboardHighlighted && styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), color_1.alp(theme.colors.fade, 0.2)));
}, function (_a) {
    var _b = _a.theme, typography = _b.typography, spacing = _b.spacing, colors = _b.colors;
    return styled_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", "px;\n    padding: ", "px ", "px;\n    padding-right: ", "px;\n    color: ", ";\n\n    &:focus {\n      outline: none;\n    }\n\n    &[data-focus-visible-added] {\n      background-color: ", ";\n    }\n\n    &[data-coral-disabled] {\n      background-color: ", ";\n      color: ", ";\n      cursor: not-allowed;\n    }\n  "], ["\n    font-family: ", ";\n    font-size: ", "px;\n    padding: ", "px ", "px;\n    padding-right: ", "px;\n    color: ", ";\n\n    &:focus {\n      outline: none;\n    }\n\n    &[data-focus-visible-added] {\n      background-color: ", ";\n    }\n\n    &[data-coral-disabled] {\n      background-color: ", ";\n      color: ", ";\n      cursor: not-allowed;\n    }\n  "])), typography.main, typography.sizes.main, 2 * spacing.factor, 3 * spacing.factor, 8 * spacing.factor, colors.alternate, color_1.alp(colors.primary, 0.15), color_1.alp(colors.alternate, 0.05), color_1.alp(colors.alternate, 0.25));
});
var SelectOption = react_1.forwardRef(function (_a, ref) {
    var as = _a.as, index = _a.index, value = _a.value, disabled = _a.disabled, _b = _a.children, children = _b === void 0 ? react_1.default.createElement(react_1.default.Fragment, null, value) : _b, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, selectedIconProp = _a.selectedIcon, props = __rest(_a, ["as", "index", "value", "disabled", "children", "onBlur", "onKeyDown", "onClick", "onMouseEnter", "onMouseLeave", "selectedIcon"]);
    warnMissingIndex_1.default(index, 'SelectOption', 'SelectList');
    var idx = index;
    var _c = __read(react_acdc_1.useAcdcOptionProps(idx, value, { disabled: disabled }), 2), _d = _c[0], states = _c[1], optionRef = _d.ref, acdcClick = _d.onClick, acdcMouseEnter = _d.onMouseEnter, acdcMouseLeave = _d.onMouseLeave, htmlAttrs = __rest(_d, ["ref", "onClick", "onMouseEnter", "onMouseLeave"]);
    var handleRef = useForkRef_1.default(optionRef, ref);
    var handleClick = useWrapEvent_1.default(onClick, acdcClick);
    var handleMouseEnter = useWrapEvent_1.default(onMouseEnter, acdcMouseEnter);
    var handleMouseLeave = useWrapEvent_1.default(onMouseLeave, acdcMouseLeave);
    var _e = SelectContext_1.useSelectContext(), setOptionChild = _e.setOptionChild, selectedValue = _e.value;
    var childRef = useEventValue_1.default(children);
    react_1.useEffect(function () {
        setOptionChild(value, childRef.current);
    }, [setOptionChild, value, childRef]);
    var isSelected = value === selectedValue;
    var dataCoral = {};
    if (disabled) {
        dataCoral['data-coral-disabled'] = '';
    }
    if (isSelected) {
        dataCoral['data-coral-selected'] = '';
    }
    var colors = ThemeProvider_1.useThemeContext().colors;
    var selectedIcon = fallback_1.default(selectedIconProp, isSelected && react_1.default.createElement(StyledSelectedIcon, { color: colors.primary }));
    return (react_1.default.createElement(Option, __assign({ as: as, ref: handleRef, "aria-disabled": disabled, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, dataCoral, states, htmlAttrs, props),
        children,
        selectedIcon));
});
exports.default = react_1.memo(SelectOption);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
